import { render, staticRenderFns } from "./GoodsClass.vue?vue&type=template&id=a423293e&scoped=true&"
import script from "./GoodsClass.vue?vue&type=script&lang=js&"
export * from "./GoodsClass.vue?vue&type=script&lang=js&"
import style0 from "./GoodsClass.vue?vue&type=style&index=0&id=a423293e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a423293e",
  null
  
)

export default component.exports